<template>
    <div>
        <div>
            <vue-headful :title="$t('title_profile')" description="title" />
        </div>
        <Snackbar :top="false" :bottom="true" />
        <v-container fluid fill-height>
            <v-row class="ma-12">
                <TopBar />
                <Banner />
                <v-col cols="12">
                    <v-row justify="center">
                        <StudentCode :code="studentCode" />
                    </v-row>
                </v-col>
                <v-row justify="center" justify-lg="space-between">
                    <Summary />
                    <GlobalProgress :progress="globalProgress" />
                </v-row>
                <Abilities :progress="skills" />
                <Achievements />
                <v-row justify="center" justify-lg="space-between" class="mt-6">
                    <Collection />
                    <Store />
                </v-row>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import Abilities from '@/components/profile/Abilities.vue'
import Achievements from '@/components/profile/Achievements.vue'
import Banner from '@/components/profile/Banner.vue'
import Collection from '@/components/profile/Collection.vue'
import GlobalProgress from '@/components/profile/GlobalProgress.vue'
import Store from '@/components/profile/Store.vue'
import Summary from '@/components/profile/Summary.vue'
import StudentCode from '@/components/profile/StudentCode.vue'
import TopBar from '@/components/home/TopBar.vue'
import Snackbar from '@/components/core/Snackbar.vue'
import GamificationService from '../../services/gamification'
import UsersServices from '../../services/users'
import ReportService from '../../services/report'

const defaultSkills = [
    {   index: 0,
        localizar: 0,
        reflexionar: 0,
        integrar: 0
    }
]

export default {
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
    },
    components: {
        Abilities,
        Achievements,
        Banner,
        Collection,
        GlobalProgress,
        Store,
        Summary,
        TopBar,
        StudentCode,
        Snackbar
    },
    data() {
        return {
            globalProgress: null,
            skills: defaultSkills,
            studentCode: '',
        }
    },
    created() {
        this.getEvolution()
        this.getGamification()
        this.getStudentCode()
    },
    mounted() {
        window.ChurnZero.push(['trackEvent', 'profile', 'Go to Profile']);
    },
    methods: {
        ...mapActions('userData', [
            'setGamification',
        ]),
        getEvolution() {
            ReportService.getEvolutionByReader(
                this.user.id
            )
            .then((response) => {
                this.setGlobalProgress(response.content.evolution)
                this.setAbilities(response.content.skills)
            })
            .catch((error) => console.error(error))
        },
        getGamification() {
            GamificationService.getUserGameStatsByUser(
                this.user.id
            )
            .then((response) => {
                if (response.content.id) {
                    this.setGamification(response.content)
                }
            })
            .catch((error) => console.error(error))
        },
        getStudentCode() {
            UsersServices.getStudentCode(this.user.id)
                .then(resp => { this.studentCode = resp.content.codeToAssociate })
                .catch(err => Sentry.captureException(err))
        },
        setGlobalProgress(data) {
            this.globalProgress = data
        },
        setAbilities(data) {
            this.skills = data
        }
    }
}
</script>
